import * as S from '@effect/schema/Schema';
import { CommunityConfiguration, CustomField, NotificationPreferences, ShippingAddress, SocialAccount } from '@infl-ts/ui-advocate-components';
import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
export var Level = t.type({
  id: t.string,
  name: t.string
});
export var NextLevelProgress = t.type({
  earnedBadgesCount: nullable(t.number),
  level: Level,
  requiredBadgesCount: nullable(t.number)
});
export var Language = t.type({
  id: t.string,
  name: t.string,
  displayName: t.string,
  code: t.string
});
export var Profile = t.type({
  avatarUrl: nullable(t.string),
  company: nullable(t.string),
  customFields: nullable(t.array(CustomField)),
  email: t.string,
  id: t.string,
  name: t.string,
  notificationPreferences: NotificationPreferences,
  shippingAddress: nullable(ShippingAddress),
  socialAccounts: t.array(SocialAccount),
  timezone: nullable(t.string),
  title: nullable(t.string),
  username: t.string,
  language: Language
});
export var GetProfileQuery = t.type({
  profile: Profile,
  communityConfiguration: CommunityConfiguration
});
export var EditProfileBlockConfig = S.struct({
  typename: S.literal('EditProfileBlock'),
  id: S.string,
  hash: S.string
});